// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./Kendo/2020.2.617/styles/kendo.common-material.min.css
// module id = 948
// module chunks = 3